import React from 'react';
import PropTypes from 'prop-types';
import SubmissionsJobPageContent from './submissionsJobPageContent';
import SubmissionsTaskPageContent from './submissionsTaskPageContent';

class SubmissionsPageContent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      model: 'task',
    };
  }

  _onModelChange = (model) => {
    this.setState({ model });
  }

  render() {
    if (this.state.model === 'task') {
      return (
        <SubmissionsTaskPageContent onModelChange={this._onModelChange}>
          {this.props.children}
        </SubmissionsTaskPageContent>
      );
    }

    return (
      <SubmissionsJobPageContent onModelChange={this._onModelChange}>
        {this.props.children}
      </SubmissionsJobPageContent>
    );
  }
}

SubmissionsPageContent.displayName = 'Submissions Page Content';

SubmissionsPageContent.propTypes = {
  children: PropTypes.node,
};

SubmissionsPageContent.defaultProps = {
  children: null,
};

export default SubmissionsPageContent;
